import { useTranslation } from 'next-i18next/pages'
import styles from './Faq.module.scss'
import type { FaqPageProps } from './types'
import { Container, Header, Heading, Icon, Img } from '@boltenergy-be/design-system'
import FaqWithDefaultDescription from 'components/faq-with-default-description/FaqWithDefaultDescription'
import Link from 'components/link/Link'
import { PhoneAvailability } from 'components/phone-availibility/PhoneAvailability'
import { useRouter } from 'next/router'
import { BOLT_EMAIL, BOLT_PHONE } from 'constants/constants'
import { Language } from 'types/language'

const Faq = ({ sections }: FaqPageProps) => {
  // i18n
  const { t } = useTranslation(['faq', 'common'])

  // Router
  const { locale } = useRouter()

  // Constants
  const isFrench = locale === Language.FRENCH
  const email = BOLT_EMAIL[locale as Language.DUTCH | Language.FRENCH]

  return (
    <main>
      {/* HERO */}
      <Header title={t('title', 'Veelgestelde vragen')} color="light" classnames={{ container: styles['header-container'] }}>
        <p>{t('description')}</p>
      </Header>

      <Container as="section" inset color="dark" classnames={{ content: styles['contact-content'] }}>
        <div className={styles.info}>
          <Heading as="h2" serif>
            <PhoneAvailability />
          </Heading>

          <address className={styles['contact-info']}>
            <div>
              <Icon name="envelope" />
              <Link as="a" href={`mailto:${email}`} variant="inline">
                {email}
              </Link>
            </div>

            <div>
              <Icon name="smartPhone" />
              <Link as="a" href={`tel:${BOLT_PHONE}`} variant="inline">
                {BOLT_PHONE}
              </Link>
            </div>

            <div>
              <Icon name="location" />
              {isFrench ? (
                <p>
                  Bolt, Botanic Tower
                  <br />
                  Bd Saint-Lazare 4-10
                  <br />
                  1210 Bruxelles
                </p>
              ) : (
                <p>
                  Bolt, Botanic Tower
                  <br />
                  Sint-Lazaruslaan 4-10
                  <br />
                  1210 Brussel
                </p>
              )}
            </div>
          </address>
        </div>

        <Img publicId="website/common/customer-care-bolt" fill className={styles.team} alt="" />
      </Container>

      {/* QUESTIONS */}
      <FaqWithDefaultDescription title={t('questionsTitle', 'Veelgestelde vragen')} categories={sections} />
    </main>
  )
}

export default Faq
